<template>
  <div class="w-full p-4 text-sm">
    <p class="text-white uppercase tracking-widest mb-2">Sort</p>

    <div v-for="_sort in sorts" class="w-full grid grid-cols-4">
      <div class="col-span-3">
        <p>{{ _sort.name }}</p>
      </div>

      <div class="w-full flex justify-end items-center">
        <button @click="selectSort(_sort)" class="btn btn-ghost btn-xs">{{ _sort.ascending ? "Low → High" : "High → Low"
        }}</button>
      </div>
    </div>

    <p class="text-white uppercase tracking-widest mt-8 mb-2">Filters</p>

    <div class="mb-6" v-for="group in filterGroups">
      <p class="mb-2 font-bold" v-if="group.name">{{ group.name }}</p>

      <div class="w-full pl-2">
        <template v-for="_filter in group.filters">
          <div @click="selectFilter(_filter)"
            class="w-full flex justify-between items-center hover:bg-white/5 p-2 rounded-md cursor-pointer">
            <div class="flex justify-start items-center w-full space-x-2">
              <img v-if="_filter.image" class="w-6 h-6 border flex-shrink-0 border-white/50 rounded-md"
                :src="_filter.image" alt="" />
              <p class="col-span-4 text-left">{{ _filter.name }}</p>
            </div>

            <div class="w-full flex justify-end items-center">
              <UCheckbox v-model="_filter.selected" :ui="{ color: 'text-woodsmoke-700 dark:text-woodsmoke-700' }" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>


const emit = defineEmits(["filterChanged", "sortChanged"]);

function selectSort(s) {
  s.ascending = !s.ascending
  emit("sortChanged", {value: [s]})
}


let filterThrottle = false;

function selectFilter(f) {
  f.selected = !f.selected

  if (filterThrottle) {
    clearTimeout(filterThrottle);
  }

  filterThrottle = setTimeout(() => { emit("filterChanged", filterGroups) }, 500);
}

const sorts = ref([
  { name: "Price", value: "price", ascending: true },
  { name: "Allocation", value: "allocation", ascending: true },
  { name: "Markup", value: "markup", ascending: true },
]);

const filterGroups = ref([
  // {
  //   name: false,
  //   filters: [{ name: "My Listing Only", value: "my_listing_only", selected: false }],
  // },
  //{
  //  name: "Project",
  //  filters: [
  //    { name: "Project Name", value: "project_name", selected: false, image: "https://picsum.photos/300/400" },
  //    { name: "Project Name", value: "project_name", selected: false, image: "https://picsum.photos/300/400" },
  //    { name: "Project Name", value: "project_name", selected: false, image: "https://picsum.photos/300/400" },
  //  ],
  //},
  // {
  //   name: "Status",
  //   filters: [
  //     { name: "Pre-contribute", value: "before", selected: false },
  //     { name: "Concluded", value: "after", selected: false },
  //   ],
  // },
  {
    name: "Pool qualification",
    filters: [
      { name: "Tier 1", value: "tier1", selected: false },
      { name: "Tier 2", value: "tier2", selected: false },
      { name: "Tier 3", value: "tier3", selected: false },
    ],
  },
]);
</script>

<style></style>
